/* eslint-disable react/no-unknown-property */

import React from 'react'

import './ScratchBlockSvgFilters.scss'

export const ScratchBlockSvgFilters = () => {
  return (
    <svg className="c-scratchblock-svg-filters">
      <defs>
        <filter id="bevelFilter" x0="-50%" y0="-50%" width="200%" height="200%">
          <feGaussianBlur result="blur-1" in="SourceAlpha" stdDeviation="1 1" />
          <feFlood
            result="flood-2"
            in="undefined"
            floodColor="#fff"
            floodOpacity="0.15"
          />
          <feOffset result="offset-3" in="blur-1" dx="1" dy="1" />
          <feComposite
            result="comp-4"
            operator="arithmetic"
            in="SourceAlpha"
            in2="offset-3"
            k2="1"
            k3="-1"
          />
          <feComposite
            result="comp-5"
            operator="in"
            in="flood-2"
            in2="comp-4"
          />
          <feFlood
            result="flood-6"
            in="undefined"
            floodColor="#000"
            floodOpacity="0.7"
          />
          <feOffset result="offset-7" in="blur-1" dx="-1" dy="-1" />
          <feComposite
            result="comp-8"
            operator="arithmetic"
            in="SourceAlpha"
            in2="offset-7"
            k2="1"
            k3="-1"
          />
          <feComposite
            result="comp-9"
            operator="in"
            in="flood-6"
            in2="comp-8"
          />
          <feMerge result="merge-10">
            <feMergeNode in="SourceGraphic" />
            <feMergeNode in="comp-5" />
            <feMergeNode in="comp-9" />
          </feMerge>
        </filter>
        <filter
          id="inputBevelFilter"
          x0="-50%"
          y0="-50%"
          width="200%"
          height="200%"
        >
          <feGaussianBlur result="blur-1" in="SourceAlpha" stdDeviation="1 1" />
          <feFlood
            result="flood-2"
            in="undefined"
            floodColor="#fff"
            floodOpacity="0.15"
          />
          <feOffset result="offset-3" in="blur-1" dx="-1" dy="-1" />
          <feComposite
            result="comp-4"
            operator="arithmetic"
            in="SourceAlpha"
            in2="offset-3"
            k2="1"
            k3="-1"
          />
          <feComposite
            result="comp-5"
            operator="in"
            in="flood-2"
            in2="comp-4"
          />
          <feFlood
            result="flood-6"
            in="undefined"
            floodColor="#000"
            floodOpacity="0.7"
          />
          <feOffset result="offset-7" in="blur-1" dx="1" dy="1" />
          <feComposite
            result="comp-8"
            operator="arithmetic"
            in="SourceAlpha"
            in2="offset-7"
            k2="1"
            k3="-1"
          />
          <feComposite
            result="comp-9"
            operator="in"
            in="flood-6"
            in2="comp-8"
          />
          <feMerge result="merge-10">
            <feMergeNode in="SourceGraphic" />
            <feMergeNode in="comp-5" />
            <feMergeNode in="comp-9" />
          </feMerge>
        </filter>
        <filter
          id="inputDarkFilter"
          x0="-50%"
          y0="-50%"
          width="200%"
          height="200%"
        >
          <feFlood
            result="flood-1"
            in="undefined"
            floodColor="#000"
            floodOpacity="0.2"
          />
          <feComposite
            result="comp-2"
            operator="in"
            in="flood-1"
            in2="SourceAlpha"
          />
          <feMerge result="merge-3">
            <feMergeNode in="SourceGraphic" />
            <feMergeNode in="comp-2" />
          </feMerge>
        </filter>
        <path
          d="M1.504 21L0 19.493 4.567 0h1.948l-.5 2.418s1.002-.502 3.006 0c2.006.503 3.008 2.01 6.517 2.01 3.508 0 4.463-.545 4.463-.545l-.823 9.892s-2.137 1.005-5.144.696c-3.007-.307-3.007-2.007-6.014-2.51-3.008-.502-4.512.503-4.512.503L1.504 21z"
          fill="#3f8d15"
          id="greenFlag"
        />
        <path
          d="M6.724 0C3.01 0 0 2.91 0 6.5c0 2.316 1.253 4.35 3.14 5.5H5.17v-1.256C3.364 10.126 2.07 8.46 2.07 6.5 2.07 4.015 4.152 2 6.723 2c1.14 0 2.184.396 2.993 1.053L8.31 4.13c-.45.344-.398.826.11 1.08L15 8.5 13.858.992c-.083-.547-.514-.714-.963-.37l-1.532 1.172A6.825 6.825 0 0 0 6.723 0z"
          fill="#fff"
          id="turnRight"
        />
        <path
          d="M3.637 1.794A6.825 6.825 0 0 1 8.277 0C11.99 0 15 2.91 15 6.5c0 2.316-1.253 4.35-3.14 5.5H9.83v-1.256c1.808-.618 3.103-2.285 3.103-4.244 0-2.485-2.083-4.5-4.654-4.5-1.14 0-2.184.396-2.993 1.053L6.69 4.13c.45.344.398.826-.11 1.08L0 8.5 1.142.992c.083-.547.514-.714.963-.37l1.532 1.172z"
          fill="#fff"
          id="turnLeft"
        />
        <g id="loopArrow">
          <path
            d="M8 0l2 -2l0 -3l3 0l-4 -5l-4 5l3 0l0 3l-8 0l0 2"
            fill="#000"
            opacity="0.3"
          />
          <path
            d="M8 0l2 -2l0 -3l3 0l-4 -5l-4 5l3 0l0 3l-8 0l0 2"
            fill="#fff"
            opacity="0.9"
            transform="translate(-1 -1)"
          />
        </g>
      </defs>
    </svg>
  )
}

export default ScratchBlockSvgFilters
